// extracted by mini-css-extract-plugin
export default {"markAllAsReadButton":"NotificationsTabTitle_markAllAsReadButton__K5XJ5","tabTitle":"NotificationsTabTitle_tabTitle__9qlsL"};